<template>
  <div class="login-container">
    <div class="login-box">
      <div class="tab-header">
        <div 
          :class="['tab-item', isLoginMode ? 'active' : '']" 
          @click="isLoginMode = true"
        >
          登录
        </div>
        <div 
          :class="['tab-item', !isLoginMode ? 'active' : '']" 
          @click="isLoginMode = false"
        >
          注册
        </div>
      </div>

      <!-- 登录表单 -->
      <div v-if="isLoginMode" class="form-container">
        <div class="input-group">
          <input 
            type="text" 
            v-model="loginForm.username" 
            placeholder="请输入账号"
            class="input-field"
          />
        </div>
        <div class="input-group">
          <input 
            type="password" 
            v-model="loginForm.password" 
            placeholder="请输入密码"
            class="input-field"
          />
        </div>
        <p v-if="loginError" class="error-message">{{ loginError }}</p>
        <button 
          class="submit-btn" 
          @click="handleLogin" 
          :disabled="isLoading"
        >
          {{ isLoading ? '登录中...' : '登录' }}
        </button>
      </div>

      <!-- 注册表单 -->
      <div v-else class="form-container">
        <div class="input-group">
          <input 
            type="text" 
            v-model="registerForm.username" 
            placeholder="请输入账号"
            class="input-field"
          />
        </div>
        <div class="input-group">
          <input 
            type="password" 
            v-model="registerForm.password" 
            placeholder="请输入密码"
            class="input-field"
          />
        </div>
        <div class="input-group">
          <input 
            type="password" 
            v-model="registerForm.confirmPassword" 
            placeholder="请确认密码"
            class="input-field"
          />
        </div>
        <p v-if="registerError" class="error-message">{{ registerError }}</p>
        <button 
          class="submit-btn" 
          @click="handleRegister"
          :disabled="isLoading"
        >
          {{ isLoading ? '注册中...' : '注册' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '../utils/axios';
import { useRouter } from 'vue-router';

export default {
  name: 'LoginView',
  setup() {
    const router = useRouter();
    return { router };
  },
  data() {
    return {
      isLoginMode: true,
      isLoading: false,
      loginError: '',
      registerError: '',
      loginForm: {
        username: '',
        password: ''
      },
      registerForm: {
        username: '',
        password: '',
        confirmPassword: ''
      }
    }
  },
  methods: {
    async handleLogin() {
      if (!this.loginForm.username.trim() || !this.loginForm.password.trim()) {
        this.loginError = '请填写完整的登录信息';
        return;
      }
      
      this.isLoading = true;
      this.loginError = '';
      
      try {
        const response = await api.login(this.loginForm);
        
        if (response.success) {
          // 保存令牌和用户信息
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          
          // 跳转到首页
          this.router.push('/');
        } else {
          this.loginError = response.message || '登录失败';
        }
      } catch (error) {
        console.error('登录错误:', error);
        if (error.response && error.response.data) {
          this.loginError = error.response.data.message || '登录失败，请稍后重试';
        } else {
          this.loginError = '网络错误，请检查您的网络连接';
        }
      } finally {
        this.isLoading = false;
      }
    },
    
    async handleRegister() {
      // 表单验证
      if (!this.registerForm.username.trim() || 
          !this.registerForm.password.trim() || 
          !this.registerForm.confirmPassword.trim()) {
        this.registerError = '请填写完整的注册信息';
        return;
      }
      
      if (this.registerForm.username.length < 3) {
        this.registerError = '用户名长度不能少于3个字符';
        return;
      }
      
      if (this.registerForm.password.length < 6) {
        this.registerError = '密码长度不能少于6个字符';
        return;
      }
      
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.registerError = '两次输入的密码不一致';
        return;
      }
      
      this.isLoading = true;
      this.registerError = '';
      
      try {
        const response = await api.register(this.registerForm);
        
        if (response.success) {
          // 保存令牌和用户信息
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          
          // 跳转到首页
          this.router.push('/');
        } else {
          this.registerError = response.message || '注册失败';
        }
      } catch (error) {
        console.error('注册错误:', error);
        if (error.response && error.response.data) {
          this.registerError = error.response.data.message || '注册失败，请稍后重试';
        } else {
          this.registerError = '网络错误，请检查您的网络连接';
        }
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  padding: 1rem;
}

.login-box {
  width: 100%;
  max-width: 320px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.tab-header {
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 1rem;
  font-size: 1rem;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.tab-item.active {
  color: #1296db;
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #1296db;
}

.form-container {
  padding: 1.5rem;
}

.input-group {
  margin-bottom: 1rem;
}

.input-field {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.input-field:focus {
  outline: none;
  border-color: #1296db;
  box-shadow: 0 0 0 2px rgba(18, 150, 219, 0.1);
}

.error-message {
  color: #f44336;
  font-size: 0.85rem;
  margin-bottom: 1rem;
  text-align: center;
}

.submit-btn {
  width: 100%;
  padding: 0.8rem;
  background: linear-gradient(135deg, #1296db, #64b5f6);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.submit-btn:not(:disabled):hover {
  background: linear-gradient(135deg, #0d87c7, #42a5f5);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(18, 150, 219, 0.2);
}

.submit-btn:not(:disabled):active {
  transform: translateY(1px);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* 适配小屏幕设备 */
@media screen and (max-width: 320px) {
  .login-box {
    margin: 1rem;
  }

  .tab-item {
    font-size: 0.9rem;
    padding: 0.8rem;
  }

  .input-field {
    font-size: 0.9rem;
    padding: 0.7rem;
  }

  .submit-btn {
    font-size: 0.9rem;
    padding: 0.7rem;
  }
}
</style> 